import styled, { css } from 'styled-components';

export const ToastsList = styled.div`
  ${({ theme: { zIndex, spacing } }) => css`
    display: flex;
    flex-direction: column;
    z-index: ${zIndex.toast};
    position: fixed;
    left: 0;
    bottom: 0;
    grid-gap: ${spacing.km4};

    fuel-toast {
      left: ${spacing.km10};
      position: relative;
      width: min-content;
    }
  `}
`;
